import React, { Component } from 'react'
import { Route, withRouter } from 'react-router-dom'

class PublicRoute extends Component {
  componentDidMount() {
    if (this.props.scrollToTop) {
      window.scrollTo(0, 0)
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.scrollToTop && this.props.location !== prevProps.location) {
      window.scrollTo(0, 0)
    }
  }

  render() {
    const { component: Component, appName, ...rest } = this.props

    return <Route {...rest} render={props => (
      <Component {...props} {...props.match.params} appName={appName} path={props.location.pathname}/>
    )}/>
  }
}

export default withRouter(PublicRoute)


// WEBPACK FOOTER //
// ./src/components/Routes/PublicRoute.js